<template>
    <project-step-container
            prev-to="be_rapid_experiments_with_customers_17"
            :on-discard-project="redirection"
            :on-keep-version-project="redirection"
            @next-click="updateProject"
    >
        <b-row>
            <b-col cols="12" class="main-text pb-3" tabindex="0">
            {{getMessage(18, 'rapidexperiment-sub')}}
            </b-col>
        </b-row>

        <LinkStyleGuide @open-url="openGuide" icon-name="icon-guide"  :text="getMessage(18, 'rapidexperiment-guide')" />

        <b-row class="mt-3">
            <b-col cols="12" class="mt-3">
                <label for="first-thing">{{getMessage(18, 'firstAssumption')}}</label>
                <input id="first-thing" type="text" v-model="form.firstAssumption"/>
            </b-col>
            <b-col cols="12" class="mt-3">
                <label for="second-thing">{{getMessage(18, 'secondAssumption')}}</label>
                <input id="second-thing" type="text" v-model="form.secondAssumption"/>
            </b-col>
            <b-col cols="12" class="mt-3">
                <label for="third-thing">{{getMessage(18, 'thirdAssumption')}}</label>
                <input id="third-thing" type="text" v-model="form.thirdAssumption"/>
            </b-col>
        </b-row>
        <project-style-guide :style-guide="styleGuide"/>
    </project-step-container>
</template>

<script>
    import Steps from "../Utils/steps";
    import {Storage, Project, ConflictSyn, StyleGuides} from "../../../core/Utils"
    import ProjectStepContainer from "../../../core/Components/ProjectStepContainer"
    import LinkStyleGuide from "../../../core/Components/LinkStyleGuide"
    import ProjectStyleGuide from "../../../core/Components/ProjectStyleGuide";

    export default {
        name: "RapidExperimentsWithCustomers18",
        components: {ProjectStepContainer , LinkStyleGuide, ProjectStyleGuide},
        data() {
            return {
                step: Steps.FORM_LOF_ASSUMPTIONS,
                urlNextProject:'be_rapid_experiments_with_customers_19',
                styleGuide: StyleGuides.getStyleGuide(StyleGuides.LEAP_FAITH_ASSUMPTIONS),
                form: {
                    firstAssumption: "",
                    secondAssumption: "",
                    thirdAssumption: ""
                }
            }
        },
        mounted() {
            const forms = Storage.getProjectForms(this.$route.params.index)
            if (this.step in forms) this.form = forms[this.step]
        },
        methods: {
            openGuide() {
                this.$bvModal.show('project-style-guide')
            },
            updateProject() {
                const stepNumber = Steps.getStepFromForm(this.step)
                const index = this.$route.params.index
                Project.saveProjectStep(index, this.step, stepNumber, this.form, this.isOffline, this.isGuest).then(response => {
                    if (response.project?.hasDifferenceVersion) {
                        ConflictSyn.show(response.index, response.project)
                    } else {
                        this.redirection()
                    }
                }).catch(err => {
                    this.redirection()
                })
            },
            redirection(){
                const index = this.$route.params.index
                this.$router.push({name: this.urlNextProject, params: {index}})
            }
        }
    }
</script>